import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGoalFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "transparent",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.46 13.7773C18.6264 14.3415 20.8643 15.6817 20.8643 17.2351C20.8643 19.3207 16.898 21.0017 12.0032 21.0017C7.10941 21.0017 3.13281 19.3207 3.13281 17.2351C3.13281 15.6817 5.36045 14.3518 8.5372 13.7773M11.997 9.85483L19.1967 6.4269L11.997 3V16.7097",
		stroke: "#596180",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "transparent"
	})
});
export default SvgGoalFlag;
